// startup
// Load entry module and return exports
__webpack_require__(98);
// This entry module used 'module' so it can't be inlined
__webpack_require__(1268);
__webpack_require__(7665);
var __webpack_exports__ = __webpack_require__(956);
